import React, { useState, useRef, useEffect } from 'react';
import '../styles.css';
import { useNavigate } from 'react-router-dom';
import { handleTouchStart } from '../utils/toucheStart';
import { handleTouchEnd } from '../utils/touchEnd';
import { formatDateToDDMMYYYY } from '../utils/dateFormatters';
import { calculateTotalExpenses } from '../utils/expenseCalculations';
import { handleNoteClick } from '../utils/noteClickHandlers';
import { handleDeleteNote } from '../utils/noteHandlers';

function NoteCard({ note, onDelete }) {
  const [isSwiped, setIsSwiped] = useState(false);
  const [totalExpenses, setTotalExpenses] = useState(0);
  const touchStartX = useRef(0);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchTotalExpenses = async () => {
      try {
        const response = await fetch(`/api/get-expenses/${note.id_note}`, {
          method: 'GET',
          credentials: 'include'
        });

        if (!response.ok) {
          throw new Error('Erreur lors de la récupération des dépenses');
        }

        const expenses = await response.json();
        const total = calculateTotalExpenses(expenses);
        setTotalExpenses(total);
      } catch (error) {
        console.error('Erreur:', error);
      }
    };

    if (note.id_note) {
      fetchTotalExpenses();
    }
  }, [note.id_note]);

  const handleClick = (e) => {
    e.stopPropagation();
    handleNoteClick(note.id_note, isSwiped, setIsSwiped, navigate);
  };

  const handleDeleteClick = (e) => {
    e.stopPropagation();
    e.preventDefault();
    handleDeleteNote(note.id_note, onDelete);
  };

  const statusClass = `note-card ${note.statut.toLowerCase().replace(' ', '-')}`;

  return (
    <div 
      className="note-container"
      onTouchStart={(e) => {
        e.stopPropagation();
        handleTouchStart(e, touchStartX);
      }}
      onTouchEnd={(e) => {
        e.stopPropagation();
        handleTouchEnd(e, touchStartX, setIsSwiped);
      }}
      style={{ position: 'relative' }}
    >
      <div 
        className={statusClass}
        style={{
          position: 'relative',
          transform: isSwiped ? 'translateX(-100px)' : 'translateX(0)',
          transition: 'transform 0.3s ease',
          cursor: 'pointer'
        }}
        onClick={handleClick}
      >
        <div className="note-header">
          <h3>{note.nom_note !== undefined ? note.nom_note : "Aucune description"}</h3>
          <span className="note-depense">
            {parseFloat(totalExpenses).toLocaleString('fr-FR', { 
              minimumFractionDigits: 2, 
              maximumFractionDigits: 2 
            })}€
          </span>
        </div>
        {/* <p>Date: {getMonthName(note.mois)} {note.annee}</p> */}
        {note.statut === 'payee' && note.date_validation && (
          <p className="validation-date">
            <i className="fa-solid fa-check-circle"></i> Validée le {formatDateToDDMMYYYY(note.date_validation)}
          </p>
        )}
      </div>
      
      <button 
        className="delete-button"
        onClick={handleDeleteClick}
        onTouchStart={(e) => e.stopPropagation()}
        onTouchEnd={(e) => e.stopPropagation()}
      >
        <i className="fa-regular fa-trash-can"></i>
      </button>
    </div>
  );
}

export default NoteCard;
